import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntitySelectDialog } from '@/common/dialog/EntitySelectDialog';
import { useForm } from '@/common/form/FormContext';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

export const XAxisButton = ({ options }) => {
  const { formValues, assignValue } = useForm();
  const { openDialog } = useDialog();
  const [anchorEl, setAnchorEl] = useState(null);

  // Mirrors EntitySelect's multiple-select dialog so it opens on the same click as the menu selection
  const openEntitySelectDialog = (fieldDef) => {
    openDialog(EntitySelectDialog, {
      data: {
        module: fieldDef.module,
        entity: fieldDef.entity,
        multiple: true,
        field: fieldDef.field,
        expr: fieldDef.expr,
        headerChecked: formValues[fieldDef.field + 'HeaderChecked'],
        selectedIds: formValues[fieldDef.field + 'SelectedIds'],
        parentFilterEntityModule: fieldDef.parentFilterEntityModule,
        parentFilterEntity: fieldDef.parentFilterEntity,
        parentFilterFkField: fieldDef.parentFilterFkField,
      },
    }).then((res) => {
      if (res == null) return;
      const { expr, selectedCount, headerChecked, selectedIds } = res;
      assignValue(fieldDef.field, expr);
      assignValue(fieldDef.field + 'SelectedCount', selectedCount);
      assignValue(fieldDef.field + 'HeaderChecked', headerChecked);
      assignValue(fieldDef.field + 'SelectedIds', selectedIds);
    });
  };

  const select = (option) => {
    assignValue('xAxis', option.code);
    setAnchorEl(null);
    if (option.fieldDef) openEntitySelectDialog(option.fieldDef);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TitleButton icon={far.faChartBar} toolTip="X Axis" onClick={(event) => setAnchorEl(event.currentTarget)} />
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        {options.map((option) => (
          <MenuItem key={option.code} selected={formValues.xAxis === option.code} onClick={() => select(option)}>
            <ListItemText>{option.displayName}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
